// @ts-nocheck
import React, { createRef } from "react";
import BaseComponent from "../../../../base/common/BaseComponent";
import ProcedureBlock from "../../../../base/basicComponents/procedureBlock";
import PageHeader from "../../../commonComponents/pageHeaders/PageHeader";
import TaskInformation from "../../../sections/taskInfoSections";
import ProcedureInformation from "../../../sections/procedureInfoSections/readOnlyProcedureInfoSection";
import ReadOnlySupportingFileSection from "../../../sections/supportingFileSections/readOnlySupportingFileSection";
import styles from "../../procedureFileProcess/style/index.module.scss";
import NormalSpin from "../../../../base/basicComponents/spin";
import StepService from "../../../../service/stepBase/StepService";
import StepBusinessType from "../../../../service/stepBase/stepBusinessType";
import CompleteStepBusinessType from "../../../../service/stepBase/completeStepBusinessType";

const supportingFileRef = createRef();
const supportingFileTableRef = createRef();
export default class BaseTlReviewPage extends BaseComponent {
  handleReturnProcedureFileSection = () => {
    // this is an empty function
  };

  handleReturnShareTaskSection = () => {
    // this is an empty function
  };

  handleReturnPageName = () => {
    // this is an empty function
  };

  handleReturnTlReviewSection = () => {
    // this is an empty function
  };

  handleConfirmModal = () => {
    // this is an empty function
  };

  handleTlReviewPageHeader = () => {
    const { receiveDate, requestByName, procedureStepStatus } = this.props.pageProps;

    return (
      <PageHeader
        title={this.handleReturnPageName()}
        receiveDate={this._formateDate(receiveDate)}
        requestBy={requestByName}
        status={procedureStepStatus}
      />
    );
  };

  handleTlReviewTaskInformationSection = (params: any, isCompletePage: any) => {
    const { taskInfoData } = this.props.sectionProps;

    return (
      <ProcedureBlock
        className={styles.approveProcedureBlock}
        child={<TaskInformation data={taskInfoData} />}
        isShowArrow={true}
        isOpen={false}
        testid="task-info-block-arrow"
        onShowDataLoad={() => {
          // @ts-ignore
          return StepService.getStepData(
            {
              procedureStepId: params.ProcedureStepID,
              procedureTaskId: params.TaskId,
              isHistorical: isCompletePage,
            },
            this.props.setTaskInfoData,
            this.setError,
            [StepBusinessType.taskInfo]
          );
        }}
      />
    );
  };

  handleTlReviewProcedureFileSection = (params: any, isCompletePage: any) => {
    return (
      <ProcedureBlock
        className={styles.approveProcedureBlock}
        child={this.handleReturnProcedureFileSection()}
        isShowArrow={true}
        isOpen={true}
        testid="procedure-file-block-arrow"
        onShowDataLoad={() => {
          return StepService.getStepData(
            params,
            this.props.setProcedureFileData,
            this.setError,
            [
              isCompletePage
                ? CompleteStepBusinessType.procedureFile
                : StepBusinessType.procedureFile,
            ],
            StepService.getMergePayloadBySettingKey([
              CompleteStepBusinessType.procedureFile.settingKey,
            ])
          );
        }}
      />
    );
  };

  handleTlReviewSupportingFileSection = (params: any, isCompletePage: any) => {
    const { supportingTableData } = this.props;

    return (
      <ProcedureBlock
        className={styles.approveProcedureBlock}
        child={
          <ReadOnlySupportingFileSection
            supportingFileRef={supportingFileRef}
            supportingFileTableRef={supportingFileTableRef}
            supportingFileData={supportingTableData}
          />
        }
        isShowArrow={true}
        isOpen={false}
        testid="supporting-file-block-arrow"
        onShowDataLoad={() => {
          return StepService.getStepData(
            params,
            this.props.setSupportingFileData,
            this.setError,
            [
              isCompletePage
                ? CompleteStepBusinessType.supportingFile
                : StepBusinessType.supportingFile,
            ],
            StepService.getMergePayloadBySettingKey([
              CompleteStepBusinessType.supportingFile.settingKey,
            ])
          );
        }}
      />
    );
  };

  handleTlReviewProcedureInformationSection = (params: any, isCompletePage: any) => {
    const { procedureStatus } = this.props.pageProps;
    const { procedureInfoData, ppoList } = this.props.sectionProps;

    const pendingInfoList = [
      StepBusinessType.procedureOwner,
      StepBusinessType.pmpExcluded,
      StepBusinessType.primaryProcedureOwner,
    ];
    const completeInfoList = [
      CompleteStepBusinessType.procedureOwner,
      CompleteStepBusinessType.pmpExcluded,
      CompleteStepBusinessType.primaryProcedureOwner,
    ];

    return (
      <ProcedureBlock
        className={styles.approveProcedureBlock}
        child={
          <ProcedureInformation
            isShowActions={false}
            noteDisabled={true}
            ppoList={ppoList}
            procedureStatus={procedureStatus}
            isPPODisabled={true}
            submitData={procedureInfoData}
            title="Procedure Information"
          />
        }
        isShowArrow={true}
        isOpen={false}
        testid="procedure-info-block-arrow"
        onShowDataLoad={() => {
          return StepService.getStepData(
            params,
            this.props.setProcedureInfoData,
            this.setError,
            isCompletePage ? completeInfoList : pendingInfoList,
            StepService.getMergePayloadBySettingKey([
              CompleteStepBusinessType.procedureOwner.settingKey,
              CompleteStepBusinessType.pmpExcluded.settingKey,
              CompleteStepBusinessType.primaryProcedureOwner.settingKey,
            ])
          );
        }}
      />
    );
  };

  handleTlReviewShareTaskSection = (params: any, isCompletePage: any) => {
    return (
      <ProcedureBlock
        className={styles.approveProcedureBlock}
        child={this.handleReturnShareTaskSection()}
        isShowArrow={true}
        isOpen={false}
        testid="share-task-block-arrow"
        onShowDataLoad={() => {
          // @ts-ignore
          return StepService.getStepData(
            {
              ...params,
              isHistorical: isCompletePage,
              isShareTaskProcess: false,
            },
            this.props.setShareTaskData,
            this.setError,
            [StepBusinessType.shareTask]
          );
        }}
      />
    );
  };

  handleTlReviewSection = () => {
    return (
      <ProcedureBlock
        className={styles.approveProcedureFile}
        child={this.handleReturnTlReviewSection()}
        isShowArrow={true}
        isOpen={true}
        testid="tl-review-block-arrow"
      />
    );
  };

  render() {
    const { loading } = this.state;
    const params = {
      TaskId: this.props.params.ProcedureTaskId,
      ProcedureID: this.props.params.ProcedureID,
      ProcedureStepID: this.props.params.ProcedureStepID,
    };

    const isCompletePage = this.props.pageProps.procedureStepStatus === "Complete";

    return (
      <NormalSpin
        spinning={loading}
        size="large"
        children={
          // @ts-ignore
          <div className={styles.approveNewPro}>
            {this.handleTlReviewPageHeader()}
            {this.handleTlReviewTaskInformationSection(params, isCompletePage)}
            {this.handleTlReviewProcedureFileSection(params, isCompletePage)}
            {this.handleTlReviewSupportingFileSection(params, isCompletePage)}
            {this.handleTlReviewProcedureInformationSection(params, isCompletePage)}
            {this.handleTlReviewShareTaskSection(params, isCompletePage)}
            {this.handleTlReviewSection()}
            {/* @ts-ignore */}
            {this.handleConfirmModal()}
          </div>
        }
      />
    );
  }
}
